import React from "react";
import { makeStyles, Paper, Typography, Chip } from "@material-ui/core";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { i18n } from "../../../translate/i18n";
import {
  buildInsightText,
  severityLabel,
  severityColor,
  sortInsightsForDisplay,
} from "../../../helpers/buildInsightText";

const useStyles = makeStyles((theme) => ({
  section: { padding: theme.spacing(2) },
  title: { marginBottom: theme.spacing(1), fontWeight: 600 },
  row: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 0),
    fontSize: 14,
  },
  empty: { color: "#888", fontSize: 14 },
}));

const SevIcon = ({ severity }) => {
  const color = severityColor(severity);
  const sz = { style: { color, fontSize: 18 } };
  // success = logro (Sofía en acción) → check verde; resto = oportunidad → bombilla azul.
  if (severity === "success") return <CheckCircleIcon {...sz} />;
  return <EmojiObjectsIcon {...sz} />;
};

const RecommendationsPanel = ({ insights = [] }) => {
  const classes = useStyles();
  const list = sortInsightsForDisplay(insights);

  return (
    <Paper className={classes.section} elevation={2}>
      <Typography className={classes.title}>
        {i18n.t("aiAssistantStats.insights.title")}
      </Typography>
      {list.length === 0 ? (
        <div className={classes.empty}>
          {i18n.t("aiAssistantStats.empty.noData")}
        </div>
      ) : (
        list.map((ins, idx) => (
          <div key={idx} className={classes.row}>
            <SevIcon severity={ins.severity} />
            <div>
              <Chip
                size="small"
                label={severityLabel(ins.severity)}
                style={{
                  backgroundColor: severityColor(ins.severity),
                  color: "#fff",
                  marginRight: 6,
                }}
              />
              {buildInsightText(ins)}
            </div>
          </div>
        ))
      )}
    </Paper>
  );
};

export default RecommendationsPanel;
